<template>
    <div>
        <router-link to="/">
            <v-img class="img-logo-nl"  alt="logo" src="@/assets/img/logo_genl.png"></v-img>
        </router-link>
        <v-container class="d-flex align-self-center justify-center align-self-center flex-column my-8 "  >
            <div align="center" justify="center" class="align-self-center justify-center d-flex align-center" style="max-width:800px;overflow: hidden">

                <v-card class="pa-6 mt-14 align-self-center justify-center dexter"  v-if="!previewDocument && !multiple" >
                    <!-- <v-img class="logo_tam" alt="Tamaulipas Logo" src="@/assets/img/logo_nl.png"></v-img> -->
                    <v-card-title class="my-5 text-center poppinsBold justify-center   brown--text" style="word-break: break-word;" >{{txtTitle}}</v-card-title>

                    <v-divider></v-divider>

                    <v-card-subtitle class="my-5 text-center poppinsRegular justify-center d-flex"   >
                        <v-card
                        flat
                        max-width="70%"
                        class="blue-grey--text text--darken-4"
                        >
                        {{txtSubTitle}}
                        </v-card>
                    </v-card-subtitle>

                    <v-card-text class="mt-6 justify-center text-center d-flex flex-column">
                        <!-- LOGIN FORM -->
                        <label for="" class="label-form ">Ingresa aquí el código</label>
                        <v-card flat class="d-flex justify-center">
                            <v-text-field
                                class="px-16 justify-center poppinsMedium"
                                style="max-width:100%"
                                outlined required
                                v-model="documentCode"
                                :rules="[value => !!value || 'El campo es requerido.']"
                            />
                        </v-card>
                        <v-row class="pl-2 mt-2 justify-center mb-0 ">
                            <vue-recaptcha
                                :sitekey="getCaptchaSiteKey()"
                                :loadRecaptchaScript="true"
                                @verify="verifyReCaptcha"
                                @expired="expiredRecaptcha"
                            >
                            </vue-recaptcha>
                        </v-row>
                        <p class="pb-5 poppinsRegular-sm">Haz click en el recuadro blanco ubicado en la izquierda</p>
                    </v-card-text>


                    <v-card-actions>
                        <v-row align="center" class="justify-space-around mb-15">
                            <div class="d-flex flex-row">
                                <v-btn @click="validate()" :color="pantoneBlack" large class="rounded-md white--text flex-fill mr-2 poppinsMedium">Validez del documento</v-btn>
                                <!-- <v-btn @click="cancelValidate()" :color="pantoneBlack" large class="rounded-md white--text flex-fill ml-2 poppinsMedium">Cancelar</v-btn> -->
                            </div>
                        </v-row>
                    </v-card-actions>

                </v-card>
                
                <v-card class="pa-6 mt-14 align-self-center justify-center dexter" v-if="multiple"> 
                    <v-card-title class="my-5 text-center poppinsBold justify-center   brown--text" style="word-break: break-word;" >Consulta de documentos firmados</v-card-title>
                    <v-divider></v-divider>
                    <v-img class="img-folio"  alt="logo" src="@/assets/img/tramite.jpg"></v-img>
                    <v-card-subtitle class="subtitulo-ayuda">Si su documento impreso, no cuenta con el trámite id, consulte este dato en <a href="https://tramites.nl.gob.mx/">tramites.nl.gob.mx</a></v-card-subtitle>
                    <v-card-text class="mt-6 justify-center text-center d-flex flex-column">
                        <label for="" class="label-form ">Ingrese el Trámite ID</label>
                        <v-card flat class="d-flex justify-center">
                            <v-text-field
                                class="px-16 justify-center poppinsMedium"
                                style="max-width:100%"
                                outlined required
                                v-model="idTramite"
                                :rules="[value => !!value || 'El campo es requerido.']"
                            />
                        </v-card>
                    </v-card-text>
                      <v-card-actions class="my-4">
                        <v-row align="center" justify="space-around">
                            <div class="d-flex flex-row">
                                <v-btn @click="validate()" :color="pantoneBlack" large class="white--text flex-fill poppinsMedium">Validar</v-btn>
                                <!-- <v-btn @click="cancelValidate()" :color="pantoneBlack" large class="white--text flex-fill ml-2 poppinsMedium">Salir</v-btn> -->
                            </div>
                        </v-row>
                    </v-card-actions>
                </v-card>

                <v-card class="pa-6 mt-14 width-display-content" v-if="previewDocument" style="max-height: 80vh" :style="documentValid ? 'overflow: scroll' : '' ">
                    <!-- <v-img class="logo_tam" alt="Tamaulipas Logo" src="@/assets/img/logo-genl.svg"></v-img> -->
                    <v-card-title class="">Vista previa del documento</v-card-title>
                    <v-card-text>
                        <v-chip class="my-2 break-word" color="green" text-color="white" v-if="documentValid">
                            El documento es válido
                        </v-chip>
                        <v-chip class="my-2 break-word" color="red" text-color="white" v-else>
                            El documento NO es válido
                        </v-chip>

                        <div v-if="format && format.toLowerCase() === 'op'">
    
                            <v-chip 
                                v-if="end_date && !isExpired" 
                                class="my-2 break-word" 
                                color="green" 
                                text-color="white"
                            >
                                Válido al {{ end_date }}
                            </v-chip>

                            <v-chip 
                                v-else 
                                class="my-2 break-word" 
                                color="red" 
                                text-color="white"
                            >
                                Documento vencido
                            </v-chip>

                        </div>


                        <!-- LOGIN FORM -->
                        <div v-if="documentImages" class="mt-4">
                            <template v-for="(image, index) in documentImages" class="">
                                <v-img
                                    :key="'img'+index"
                                    :src="image">

                                </v-img>
                            </template>
                        </div>
                        <div v-else class="text-h4 my-16">
                            No se pudo generar una vista previa del documento.
                        </div>
                    </v-card-text>

                </v-card>
                    
                
                
            </div>

            <v-card-actions class="my-4" v-if="previewDocument">
                <v-row align="center" justify="space-around">
                    <div class="d-flex flex-row">
                        <v-btn @click="validatePageReset()" :color="pantone" large class="white--text flex-fill mr-2 poppinsMedium">Validar otro documento</v-btn>
                        <v-btn @click="cancelValidate()" :color="pantoneBlack" large class="white--text flex-fill ml-2 poppinsMedium">Salir</v-btn>
                    </div>
                </v-row>
            </v-card-actions>

        </v-container>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import {GeneralApi} from "bestgob-core/api";
import {toFormData} from "bestgob-core/core/utils";

export default {
    data() {
        return {
            pantone: '#B08C55',
            pantoneBlack: '#15212F',
            documentCode: null,
            idTramite: null,
            multiple: false,
            recaptchaVerified: false,
            formValid: false,
            showPassword: false,
            showRepeatPassword: false,
            documentImages: null,
            // test:[
            //     'https://www.ull.es/portal/marca/wp-content/uploads/sites/26/2018/05/documento-google.jpg',
            //     'https://www.ull.es/portal/marca/wp-content/uploads/sites/26/2018/05/documento-google.jpg',
            //     'https://www.ull.es/portal/marca/wp-content/uploads/sites/26/2018/05/documento-google.jpg'
            // ],
            previewDocument: false,
            documentValid: false,
            txtTitle: 'VALIDEZ DE DOCUMENTOS',
            txtSubTitle: 'Para verificar la validez del documento generado en el sistema, ingresa el codigo de verificacion ubicado en el codigo de barra en la parte inferior del documento',
            end_date: null,
            format: null,
            isExpired: null
        }
    },

    components: {VueRecaptcha},

    computed: {
        ...mapState({accountStore: state => state.account, alertsStore: state => state.alerts}),
    },

    mounted() {
        if (this.$route.query.code !== undefined){
            this.documentCode = this.$route.query.code

            if(this.documentCode){
                this.recaptchaVerified = true
                this.validate()

            }
        }
        // this.documentImages = this.test
    },

    methods: {
        ...mapActions('account', ['setNewUserPassword']),
        ...mapActions('alerts', ['success', 'error', 'showLoading', 'hideLoading']),

        async validate(){
            if (this.documentCode != null && this.recaptchaVerified){
                this.showLoading('Validando el documento, espere un momento.')
                if(!this.idTramite){
                    console.log('mando code');
                    GeneralApi.validateDocument(toFormData({code: this.documentCode}))
                    .then(data => {
                        console.log(data);
                        if(data.multiple){
                            this.multiple = true
                            this.hideLoading()
                        }else{
                            this.hideLoading()
                            this.success(data.message)
                            this.documentImages = data.content
                            this.previewDocument = true
                            this.documentValid = true
                            if(data.end_date){
                                const [year, month, day] = data.end_date.split('-').map(Number)
                                const dateObject = new Date(year, month - 1, day)

                                const today = new Date();
                                today.setHours(0,0,0,0);

                                this.isExpired = today > dateObject;

                                const options = {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                }
                                const readableDate = dateObject.toLocaleDateString('es-ES', options)
                                this.end_date = readableDate.replace(/\sde\s(?=\d{4})/, ' del ')
                            } else {
                                this.end_date = null
                            }
                            this.format = data.format
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.hideLoading()
                        this.error(error.message)
                        this.previewDocument = true
                    })
                }else{
                    console.log('mando idtramite');
                    GeneralApi.validateDocument(toFormData({code: this.documentCode, tramite: this.idTramite}))
                    .then(data => {
                            this.hideLoading()
                            this.success(data.message)
                            this.documentImages = data.content
                            this.previewDocument = true
                            this.documentValid = true
                            this.multiple= false
                    })
                    .catch(error => {
                        console.log(error)
                        this.hideLoading()
                        this.error(error.message)
                        this.previewDocument = true
                        this.multiple= false
                    })
                }
            
            }
        },

        validatePageReset(){
            this.$router.push({name: 'documents_validate', params: {}})
            location.reload();
        },

        getCaptchaSiteKey(){
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        verifyReCaptcha(){
            this.recaptchaVerified = true
        },

        expiredRecaptcha(){
            this.recaptchaVerified = false
        },

        cancelValidate(){
            if (this.accountStore.loggedIn){
                this.$router.push({name: 'home'})
            }else{
                this.$router.push({name: 'login'})
            }
        }
    },

};
</script>
<style>
    .subtitulo-ayuda{
        padding-top: 0px;
        position: absolute;
        margin-top: -35px;
        left: 8%;
    }
   .img-folio{
    width: 100%;
   }
    .theme--light.v-divider {
        border-color: #ff840059;
        height: 3px !important;
        border-width: thin 0px  1px  0px;
    }
    .relative {position: relative}
    .absolute {position: absolute}
    .fb-native-button{width: 100%;}
    .fb-native-button button{
        height: 36px;
        background-image: none !important;
        padding: 0 !important;
        min-width: 0 !important;
        width: 100%
    }
    .fb-native-button button img, .fb-native-button button .spinner{display: none}
    .poppinsBold{
        font-family: "PoppinsBold" !important;
        font-size: 20pt;
    }
    .poppinsMedium{
    font-family: "PoppinsMedium" !important;
    font-size: 100px;
    }
    .poppinsRegular{
        font-family: "PoppinsRegular" !important;
        font-size: 15pt;
    }
    .poppinsRegular-sm{
        font-family: "PoppinsRegular" !important;
        font-size: 10pt;
    }
    .img-logo-nl{
        width:200px;
        position: absolute;
         top:5%;
         margin-left: auto;
         margin-right: auto;
         left: 0;
         right: 0;
    }
    /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        width: 100%;
        padding: .9rem  1rem !important;
        font-size: .7rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */
    
    .v-application.fondo_login fieldset{
        /* border-bottom: 0px !important */
    }

    .parallax {
    /* The image used */
    /* background-image: url("img_parallax.jpg"); */
    background-color: #ff8400;
    /* Set a specific height */
    min-height: 500px;

    /* Create the parallax scrolling effect */
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    }

    .width-display-content{
        width: 100%;
    }

    @media only screen and (max-width: 720px) {
        .width-display-content{
            width: 600px;
        }
        .v-application .pa-6{
            padding: 10px !important;
        }
        
    }

    @media only screen and (max-width: 600px) {
        .width-display-content{
            width: 400px;
         
        }
        .v-application .pa-6{
            padding: 10px !important;
        }
    }

    @media only screen and (max-width: 420px) {
        .width-display-content{
            width: 350px;
        }
        .v-application .pa-6{
            padding: 10px !important;
        }
    }

    @media only screen and (max-width: 350px) {
        .width-display-content{
            width: 310px; 
        }
        .v-application .pa-6{
            padding: 10px !important;
        }
    }

</style>
